import { Component, input, OnInit, signal } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-success',
  standalone: false,
  templateUrl: './success.component.html',
  styleUrl: './success.component.scss',
})
export class SuccessComponent implements OnInit, ICellRendererAngularComp {
  readonly isSuccess = signal<boolean>(false);
  readonly isSuccessInput = input<boolean | undefined>(undefined);

  ngOnInit(): void {
    const input = this.isSuccessInput();
    if (input !== undefined) this.isSuccess.set(input);
  }

  agInit(params: ICellRendererParams): void {
    this.refresh(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.isSuccess.set(params.value);
    return true;
  }
}
